import { Link } from "react-router-dom";

export function Privacy() {
   return (
      <div className="min-h-full bg-white">
         <nav className="flex items-center justify-between px-6 py-4 max-w-3xl mx-auto">
            <Link to="/" className="text-xl font-bold text-primary-700">
               Launchpad
            </Link>
         </nav>

         <div className="px-6 py-12 max-w-3xl mx-auto prose prose-slate prose-sm">
            <h1 className="text-2xl font-bold text-slate-900">Privacy Policy</h1>
            <p className="text-sm text-slate-500">Last updated: June 30, 2026</p>

            <h2 className="text-lg font-semibold text-slate-800 mt-8">What we collect</h2>
            <p className="text-sm text-slate-600">
               Launchpad stores only information you explicitly enter: company names, roles, dates, notes, goals, and contact details related to your job search. We also store your email address for authentication purposes.
            </p>

            <h2 className="text-lg font-semibold text-slate-800 mt-6">How it's stored</h2>
            <p className="text-sm text-slate-600">
               Your data is stored in AWS DynamoDB (encrypted at rest) in the US-East-1 region. Authentication is handled by AWS Cognito. Each user's data is isolated — no one can access your information except you.
            </p>

            <h2 className="text-lg font-semibold text-slate-800 mt-6">What we don't do</h2>
            <ul className="text-sm text-slate-600 list-disc pl-4 space-y-1">
               <li>We don't sell your data to third parties</li>
               <li>We don't run advertising or ad tracking</li>
               <li>We don't scrape or collect data passively</li>
               <li>We don't use your data to train AI models</li>
               <li>We don't share your information with anyone unless you explicitly generate a shared progress link</li>
            </ul>

            <h2 className="text-lg font-semibold text-slate-800 mt-6">Shared progress link</h2>
            <p className="text-sm text-slate-600">
               If you generate a share link, a read-only summary of your progress (goal progress, pipeline counts, overdue items) becomes accessible via that URL. No company names, notes, contacts, or sensitive details are included. You can revoke the link at any time from Settings.
            </p>

            <h2 className="text-lg font-semibold text-slate-800 mt-6">Cookies & local storage</h2>
            <p className="text-sm text-slate-600">
               Launchpad uses browser localStorage to persist your authentication session, theme preference, and board view preference. We do not use advertising cookies or third-party tracking scripts.
            </p>

            <h2 className="text-lg font-semibold text-slate-800 mt-6">Your rights</h2>
            <ul className="text-sm text-slate-600 list-disc pl-4 space-y-1">
               <li><strong>Export</strong> — download all your data as a CSV file from Settings at any time</li>
               <li><strong>Delete</strong> — permanently remove your account and all associated data from Settings. This action is irreversible and removes everything from our systems.</li>
            </ul>

            <h2 className="text-lg font-semibold text-slate-800 mt-6">Contact</h2>
            <p className="text-sm text-slate-600">
               Questions about privacy or your data? Reach out through the in-app Help page while signed in.
            </p>
         </div>
      </div>
   );
}
